import { Box, useDisclosure } from '@chakra-ui/react';
import { useCallback, useState } from 'react';
import {
  AddAgentModal,
  RosterHeader,
  RosterTable,
  useOrganizationRoster,
} from './components/Roster';
import { useNotificationsContext } from './context/NotificationsContext';

export const NotificationsRosterPage = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { partners } = useNotificationsContext();
  const { rosterEntries, loading, refetch } = useOrganizationRoster({
    searchQuery,
  });

  const handleAddSuccess = useCallback(() => {
    void refetch();
  }, [refetch]);

  return (
    <Box px={{ base: 4, md: 10 }} py={4}>
      <RosterHeader onAddClick={onOpen} onSearchChange={setSearchQuery} />
      <RosterTable
        entries={rosterEntries}
        loading={loading}
        partners={partners}
      />
      <AddAgentModal
        isOpen={isOpen}
        onClose={onClose}
        onSuccess={handleAddSuccess}
      />
    </Box>
  );
};
